import {Input, Select} from "antd";
import {useEffect, useState} from "react";

const {TextArea} = Input;

export default function WantedJob({onChange}) {
    const [wantedJob, setWantedJob] = useState({
        title: "",
        workPlace: "",
        workType: "",
        workLocation: "",
        field: "",
        position: "",
        salary: "",
        careerObjective: ""
    });
    useEffect(() => {
        onChange(wantedJob);
    }, [wantedJob]);
    const handleChange = (key, value) => {
        setWantedJob({...wantedJob, [key]: value});
    }
    return (
        <div className="border rounded-lg p-6 shadow-md w-full bg-white">
            <h2 className="text-lg font-semibold mb-4">Tiêu đề CV <span className="text-red-500">*</span></h2>
            <Input placeholder="VD: Sinh viên tìm việc làm buồng phòng"
                   onChange={(e) => handleChange("title", e.target.value)}/>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div>
                    <label className={"text-sm font-medium"}>Nơi muốn làm việc <span
                        className="text-red-500">*</span></label>
                    <Select placeholder={"Chọn nơi muốn làm việc"} className={"w-full"}
                            onChange={(value) => handleChange("location", value)}>
                        <Select.Option value="HN">Hà Nội</Select.Option>
                        <Select.Option value="DN">Đà Nẵng</Select.Option>
                        <Select.Option value="HCM">Hồ Chí Minh</Select.Option>
                    </Select>
                </div>
                <div>
                    <label className={"text-sm font-medium"}>Hình thức làm việc <span className="text-red-500">*</span></label>
                    <Select placeholder={"Chọn hình thức làm việc"} className={"w-full"}
                            onChange={(value) => handleChange("jobType", value)}>
                        <Select.Option value="fulltime">Toàn thời gian</Select.Option>
                        <Select.Option value="parttime">Bán thời gian</Select.Option>
                    </Select>
                </div>
                <div>
                    <label className={"text-sm font-medium"}>Địa điểm làm việc <span
                        className="text-red-500">*</span></label>
                    <Select placeholder="Chọn địa điểm" style={{width: "100%"}}
                            onChange={(value) => handleChange("workPlace", value)}>
                        <Select.Option value="HN">Hà Nội</Select.Option>
                        <Select.Option value="DN">Đà Nẵng</Select.Option>
                        <Select.Option value="HCM">Hồ Chí Minh</Select.Option>
                    </Select>
                </div>
                <div>
                    <label className={"text-sm font-medium"}>Chọn lĩnh vực<span
                        className="text-red-500">*</span></label>
                    <Select className={"w-full"} placeholder={"Chọn lĩnh vực"}
                            onChange={(value) => handleChange("field", value)}>
                        <Select.Option value="it">Công nghệ thông tin</Select.Option>
                        <Select.Option value="marketing">Marketing</Select.Option>
                        <Select.Option value="sale">Bán hàng</Select.Option>
                    </Select>
                </div>
                <div>
                    <label className={"text-sm font-medium"}>Chọn vị trí <span className="text-red-500">*</span></label>
                    <Select className={"w-full"} placeholder={"Chọn vị trí"}
                            onChange={(value) => handleChange("position", value)}>
                        <Select.Option value="dev">Lập trình viên</Select.Option>
                        <Select.Option value="tester">Tester</Select.Option>
                        <Select.Option value="pm">Project Manager</Select.Option>
                    </Select>
                </div>
                <div>
                    <label className={"text-sm font-medium"}>Mức lương mong muốn <span className="text-red-500">*</span></label>
                    <Select className={"w-full"} placeholder={"Chọn mức lương"}
                            onChange={(value) => handleChange("salary", value)}>
                        <Select.Option value="1">Dưới 5 triệu</Select.Option>
                        <Select.Option value="2">5 - 10 triệu</Select.Option>
                        <Select.Option value="3">10 - 20 triệu</Select.Option>
                        <Select.Option value="4">Trên 20 triệu</Select.Option>
                    </Select>
                </div>
            </div>
            <div className={"mt-3"}>
                <label className={"text-sm font-medium"}>Mục tiêu nghề nghiệp<span
                    className="text-red-500">*</span></label>
                <TextArea rows={3} placeholder="Nhập mục tiêu nghề nghiệp của bạn"
                          onChange={(e) => handleChange("careerObjective", e.target.value)}/>
            </div>
        </div>);
}
